export const RUNTIME_OPTION = 'sas_runtime_key'

let initialized: Promise<void> | undefined
export function initSdk(): Promise<void> {
  initialized ??= new Promise((resolve, reject) => {
    if (!window.BX24 || window.parent === window) { reject(new Error('Откройте приложение внутри Битрикс24')); return }
    const timer = setTimeout(() => reject(new Error('Битрикс24 не передал данные приложения')), 15000)
    window.BX24.init(() => { clearTimeout(timer); resolve() })
  })
  return initialized
}

export async function sdkAuth(force = false) {
  await initSdk()
  const auth = force ? false : window.BX24!.getAuth()
  if (auth) return auth
  return new Promise<Exclude<ReturnType<NonNullable<Window['BX24']>['getAuth']>, false>>((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('Битрикс24 не обновил авторизацию')), 15000)
    window.BX24!.refreshAuth(next => {
      clearTimeout(timer)
      if (next) resolve(next)
      else reject(new Error('Битрикс24 не передал авторизацию'))
    })
  })
}

export async function callBitrix(method: string, params: Record<string, unknown>): Promise<any> {
  await initSdk()
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('Битрикс24 не подтвердил выполнение. Проверьте результат в портале перед повторной отправкой.')), 60000)
    window.BX24!.callMethod(method, params, result => {
      clearTimeout(timer)
      const error = result.error()
      if (error) reject(new Error(result.error_description?.() || String(error)))
      else resolve(result.data())
    })
  })
}

export async function rememberRuntimeKey(key: string) {
  await initSdk()
  if (!/^[A-Za-z0-9_-]{32,64}$/.test(key)) throw new Error('Некорректный ключ подключения')
  if (window.BX24!.appOption.get(RUNTIME_OPTION) === key) return
  if (window.BX24!.isAdmin?.()) {
    await new Promise<void>((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('Не удалось сохранить настройки приложения в Битрикс24')), 15000)
      window.BX24!.appOption.set(RUNTIME_OPTION, key, () => { clearTimeout(timer); resolve() })
    })
  }
}

export async function openBackendBootstrap() {
  await initSdk()
  const auth = await sdkAuth()
  const base = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/$/, '')
  const form = document.createElement('form')
  form.method = 'POST'; form.action = base + '/integrations/bitrix/app'
  const expires = Math.max(1, Math.floor(((auth.expires_in ?? Date.now() + 3600000) - Date.now()) / 1000))
  const data = { DOMAIN: auth.domain, member_id: auth.member_id, AUTH_ID: auth.access_token, REFRESH_ID: auth.refresh_token,
    AUTH_EXPIRES: String(expires), PLACEMENT: 'DEFAULT', PLACEMENT_OPTIONS: '{}' }
  for (const [name, value] of Object.entries(data)) {
    const input = document.createElement('input'); input.type = 'hidden'; input.name = name; input.value = String(value || ''); form.append(input)
  }
  document.body.append(form); form.submit()
}
